import React, { useContext } from "react";
import { Box, Grid, SvgIcon } from "@mui/material";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
// import WifiCallingIcon from "@mui/icons-material/WifiCalling";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { ReactComponent as SogLogo } from "../../../assets/svgs/sog-logo.svg";
import { Link } from "react-router-dom";
import { viewportSizeContext } from "../../../context/viewport-size-context";
import { PARENT_MENU_LIST } from "../Header/HeaderMenuLists";

const FooterWeb = ({ currentPage }) => {
  const isMobile = useContext(viewportSizeContext);
  return (
    <footer className={`footer-web ${isMobile ? "footer-mobile" : ""}`}>
      <div className="sog-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} className="footer-web-grid">
            <Grid size={{ xs: 12, md: 3 }}>
              <div className="footer-web-grid-logo">
                <SvgIcon
                  component={SogLogo}
                  className={"footer-logo"}
                  inheritViewBox
                />
              </div>
              <p>
                The only script expert addressing teachers’ annual day pain
                points
              </p>
            </Grid>
            <Grid size={{ xs: 12, md: 2 }} offset={{ xs: 0, md: 2 }}>
              <div className="footer-contact-details">
                <p>
                  <a href="mailto:info@scriptographer.in">
                    <EmailIcon /> info@scriptographer.in
                  </a>
                </p>
                {/* <p>
                  <a href="tel:9898989898">
                    <WifiCallingIcon /> +91-9898989898
                  </a>
                </p> */}
                <p>
                  Follow us on :{" "}
                  <a
                    href="https://twitter.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <TwitterIcon />
                  </a>
                  <a
                    href="https://www.instagram.com/scriptographer_official/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InstagramIcon />
                  </a>
                  <a
                    href="https://facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FacebookIcon />
                  </a>
                </p>
              </div>
            </Grid>
            <Grid size={{ xs: 12, md: 2 }} offset={{ xs: 0, md: 3 }}>
              <ul className="footer-web-links">
                {/* <li><a href="/home">Home</a></li> */}
                {PARENT_MENU_LIST.map((item, index) => (
                  <React.Fragment key={index}>
                    <li>
                      <Link to={item.hrefLink} replace>
                        {item.label}
                      </Link>
                    </li>
                  </React.Fragment>
                ))}

                {/* <li>
                  <Link to="/gallery" replace>
                    Gallery
                  </Link>
                </li>
                <li>
                  <Link to="/scripts" replace>
                    Scripts
                  </Link>
                </li>
                <li>
                  <Link to="/contact" replace>
                    Contact Us
                  </Link>
                </li> */}
              </ul>
            </Grid>
          </Grid>
          <Grid container spacing={2} className="footer-web-grid">
            <Grid size={{ xs: 12, md: 12 }}>
              <p className="footer-bottom-text">
                Copyright <CopyrightIcon /> 2025 Scriptographer Arts Education
              </p>
            </Grid>
          </Grid>
        </Box>
      </div>
    </footer>
  );
};

export default FooterWeb;
